import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./pitch-deck-analysis.css";
import { useParams } from "react-router-dom";
import PlanBuilderPageLayout from "../../../../layout/pitch-deck-analysis-page/index";
import { useSupabaseApp } from "../../../../SupabaseApp";
import useBusinessPlanBuilder from "../../../hooks/useBusinessPlanBuilder";
import LoadingModal from "../../../modals/loading-modal";
import {
  closeAlert,
  handleClose,
  handleEnterSave,
  handleSave,
  handleSubmit,
  scrollToTop,
} from "./helpers";

/**
 * EditPitchDeckAnalysis Component
 *
 * Edit existing pitch deck analysis documents. Allows founders to update previously
 * created pitch decks. Fetches existing pitch deck data from Realm on mount using
 * pitchDeckId from URL parameters. Uses custom useBusinessPlanBuilder hook for form
 * state management. Displays loading modal while fetching data, then renders form
 * with populated values via PlanBuilderPageLayout. Supports saving, submitting, and
 * keyboard shortcuts for efficiency. Requires user authentication.
 *
 * @returns {JSX.Element} Page with pitch deck editing form and builder interface
 */
const EditPitchDeckAnalysis = () => {
  // State to control alert component visibility
  const [alert, setAlert] = useState(true);

  // State to store alert message (initially shows LoadingModal)
  const [message, setMessage] = useState(<LoadingModal />);
  // Get pitch deck form state and dispatcher from custom hook
  const { state, dispatch } = useBusinessPlanBuilder();

  // Get current user from Supabase and pitchDeckId from URL params
  const { supabase } = useSupabaseApp();
  // Get pitchDeckId from URL route parameter for fetching specific document
  const { pitchDeckId } = useParams();

  // Realm functions to analyze, save, and fetch pitch deck documents
  // const { analyzePitchDeckDev, savePitchDeckDev, getMyPitchDeckDev } =
  //   currentUser.functions;

  // Router history for navigation
  const history = useHistory();

  // Props object containing state, handlers, and helper functions for layout
  const props = {
    state: state,
    dispatch: dispatch,
    setMessage,
    setAlert,
    message,
    alert,
    history,
    supabase,
    // analyzePitchDeckDev,
    // savePitchDeckDev,
  };

  // Props object with handler functions for layout interaction
  const params = {
    ...props,
    closeAlert: () => closeAlert(props),
    scrollToTop: () => scrollToTop(),
    handleSubmit: () => handleSubmit(props),
    handleSave: () => handleSave(props),
    handleEnterSave: (e) => handleEnterSave(e),
    handleClose: () => handleClose(props),
  };

  /**
   * Fetch existing pitch deck data from Realm on component mount
   * Uses pitchDeckId from URL params to retrieve document
   * Parses response JSON and initializes form state with existing data
   */
  useEffect(() => {
    async function getPitchDeck(id) {
      try {
        const { data, error } = await supabase.functions.invoke(
          "getMyPitchDeckDev",
          {
            body: {
              pitchDeckId: id,
            },
          },
        );
        if (error) throw error;

        dispatch({ type: "initialize", value: data });

        setAlert(false);
      } catch (err) {
        // To-do: Alert user an error was returned
        // console.error("Couldn't initialize the state. Error:", err);
      }
    }
    if (pitchDeckId) {
      getPitchDeck(pitchDeckId);
    }
  }, [dispatch, pitchDeckId, supabase]);

  // useEffect(() => {
  //   console.log('state:', state)
  // }, [state])

  return <PlanBuilderPageLayout props={params} />;
};

export default EditPitchDeckAnalysis;
